import axios from 'axios';

// Staff self-registration is deliberately separate from the normal app login:
// its own token key (sessionStorage, so it ends with the tab) and its own axios instance.
const TOKEN_KEY = 'cs_register_token';

export const getRegisterToken   = () => sessionStorage.getItem(TOKEN_KEY);
export const setRegisterToken   = (t) => sessionStorage.setItem(TOKEN_KEY, t);
export const clearRegisterToken = () => sessionStorage.removeItem(TOKEN_KEY);

const registerApi = axios.create({
  baseURL: '/api/staff-register',
  headers: { 'Content-Type': 'application/json' },
});

registerApi.interceptors.request.use((config) => {
  const token = getRegisterToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default registerApi;
